import firebase from 'firebase/app';
import moment from 'moment';

//blueprint
import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "copied-content",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Copied", intent: Intent.SUCCESS, timeout: 1000});
}

export const customCopy = (content, fbProfile , id, vProp, int, msgType, firstCopy, name, auth) =>{
    var textField= document.createElement('textarea')
    textField.innerHTML=content
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    showToast()

    firebase
        .firestore()
        .collection('organizations')
        .doc(fbProfile.company)
        .collection('prospects')
        .doc(id)
        .update({
            ProspectName: name,
            Prospected: 'Yes',
            MessageApproved: 'Yes',
            ContentCopied: content,
            InterestUsed: int,
            ProspectContentType: msgType,
            ProspectVpropUsed: vProp,
            ProspectContent: content,
            firstCopy: 1 + firstCopy.length,
            theEndOfWeek: moment().endOf('week').toDate()
        })
    
    firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('dailyCopied')
    .doc()
    .set({
        CreatedBy: fbProfile.email,
        Company: fbProfile.company,
        ProspectName: name,
        ProspectInterest: int,
        ProspectContent: content,
        ProspectValuePropUsed: vProp,
        createdAt: new Date(),
        AuthorID: auth.uid,
        AuthorFirstName: fbProfile.firstName,
        AuthorLastName: fbProfile.lastName,
    })
}